import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { HttpService } from './_services/http.service';
import { environment } from 'src/environments/environment';
import { event } from 'jquery';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { AuthenticationService } from './_services/auth.service';
import { UserService } from './_services/user.service';
import { RefreshTabsService } from './refresh-tabs.service';
import { clearModuleId, routeToModuleMap, updateModuleId } from './_utilities/moduleUtility';
import { filter } from 'rxjs/operators';

import { EventTrackingServcie, MAPTILER_CACHE_STATUS } from './analytics/event-tracking.servcie';
import { EVENTS } from './analytics/events';
import { initializeWindowListeners, clearLocalStorageExceptCharts } from './_helpers/window.helper';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit,OnDestroy {
    // @HostListener('window:beforeunload', ['$event'])
    // onBeforeUnload(event: BeforeUnloadEvent): void {
    //     event.preventDefault();
    //     this.logout(event);
    // }

    // @HostListener('window:unload', ['$event'])
    // onUnload(event: Event) {
    //     //this.logout(event);
    // }


    constructor(private primengConfig: PrimeNGConfig, private httpService: HttpService, private route: ActivatedRoute,
        private router: Router,   private authenticationService: AuthenticationService,private userService: UserService,
        private adalSvc: MsAdalAngular6Service, private tabRefreash:RefreshTabsService, private eventTrackingServcie: EventTrackingServcie) {
        }
    
    ngOnInit() {
        // Initialize window listeners
        initializeWindowListeners(MAPTILER_CACHE_STATUS);

        window.addEventListener('storage', this.onStorageChange);
        this.primengConfig.ripple = true;

        // Initialize analytics tracking service
        const currentUser = this.authenticationService.currentUserValue as any;
        if(currentUser && currentUser.user && currentUser.user.email) {
          this.eventTrackingServcie.setUserId(currentUser.user.email);
        }
        // Listen to route changes and update moduleId
        this.router.events.pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd)
        ).subscribe((event) => {
            this.handleRouteChange(event.urlAfterRedirects);
        });
    }

    private handleRouteChange(url: string): void {
    clearModuleId();

    let bestMatch: { route: string; moduleName: string } | null = null;

    for (const [route, moduleName] of Object.entries(routeToModuleMap)) {
        if (url.startsWith(route)) {
        if (!bestMatch || route.length > bestMatch.route.length) {
            bestMatch = { route, moduleName };
        }
        }
    }

    if (bestMatch) {
        updateModuleId(bestMatch.moduleName);
    }
    }

    // handleSSOToken(ssoToken: string): void {
    //  debugger
    //     const value =ssoToken;
    //         this.userService.GeoOneLoginEmail(value).then((res: any) => {
    //             if (!res.success) {
    //               // Invalid SSO token, allow access
    //               return true;
    //             }
          
    //             if (res.user.email.includes('@') && res.user.email.includes('.')) {
    //               const oAuthConfigEmail = localStorage.getItem('oAuthConfig.email');
    //               if (res.user.email) {
    //                 this.signInFromSSO(res.user.email);
    //                 return true;
    //               } else {
    //                 location.href = '/';
    //                 return false;
    //               }
    //             } else {
    //               location.href = '/';
    //               return false;
    //             }
    //           }).catch(error => {
    //             console.error('Error during SSO login:', error);
    //             return false;
    //           });

        
       
    // }

    // Method to sign in from SSO
    signInFromSSO(email: string): void {
    localStorage.setItem('oAuthConfig.email', email);
    localStorage.setItem('oAuthConfig.responseType', 'code');
    this.adalSvc.login();
  }
  

    logout(event: any) {
        if (event !== null && event !== undefined) {
            var localStorageString = localStorage.getItem('currentUser');
            const currentUserData = JSON.parse(localStorageString ? localStorageString : "");
            this.logoutAuth(currentUserData.user.userId);
            clearLocalStorageExceptCharts();
            this.eventTrackingServcie.track(EVENTS.USER_LOGGED_OUT, {});
        }
    }

    logoutAuth(userId: any): Promise<any> {
        return this.httpService.post(`api/Account/Logout`, {}, { userId: userId }, environment.authServerUrl);
    };
   
    ngOnDestroy(): void {
      window.removeEventListener('storage', this.onStorageChange);
    }
   
    private onStorageChange(event: StorageEvent): void {
      if (event.key === 'reloadTabs' && event.newValue === 'true') {
        location.reload();  // Reload the tab
      }
    }
      
}
